import SteveAndKateLogo from '@/images/bh-benefits/steve_and_kates.svg';
import ProHouseKeepersLogo from '@/images/bh-benefits/pro-house-keepers-logo.svg';
import GTMLogo from '@/images/bh-benefits/gtm-logo.svg';
import ProTrainingsLogo from '@/images/bh-benefits/pro-trainings-logo.svg';
import BrightHorizonsLogo from '@/images/bh-benefits/bright-horizons-logo.svg';
import MeetCaregiversLogo from '@/images/bh-benefits/meetcaregivers-logo.svg';
import GrayceElderCareLogo from '@/images/bh-benefits/grayce-elder-care-logo.svg';

/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
enum PartnerCategory {
  childCareCamps = 'Childcare & Camps',
  houseKeeping = 'Housekeeping',
  careSupport = 'Care & Support',
  test = 'Test Category',
  enrichment = 'Enrichment',
  caregiverDevelopment = 'Caregiver Development',
}
/* eslint-enable no-unused-vars */

export interface PartnerTile {
  logoImage: string;
  companyName: string;
  headerText: string;
  bodyText: string;
  ctaText: string;
  ctaLink: string;
  category: PartnerCategory;
}

const GTM_PARTNER_KEY = 'GTM_Payroll_Care_Support';
const GTM_PARTNER_TILE_DATA: PartnerTile = {
  logoImage: GTMLogo,
  companyName: 'GTM Payroll',
  headerText: 'All-In-One, Easy-to-Use Nanny Payroll',
  bodyText: 'Make payday and nanny taxes hassle-free with GTM Payroll',
  ctaText: 'Learn more',
  ctaLink: 'https://gtm.com/household/sittercity/',
  category: PartnerCategory.careSupport,
};

const STEVE_AND_KATES_CAMPS_KEY = 'SteveandKates_Camps';
const STEVE_AND_KATES_CAMPS_TILE_DATA: PartnerTile = {
  logoImage: SteveAndKateLogo,
  companyName: "Steve & Kate's Camp",
  category: PartnerCategory.childCareCamps,
  headerText: 'Flexible Summer & Holiday Camps',
  bodyText: 'Putting kids ages 4-12 in charge since 1980. Now enrolling',
  ctaText: 'Learn More',
  ctaLink:
    'https://steveandkatescamp.com/bh-family-benefits/?utm_source=sittercity&utm_medium=campTile&utm_campaign=sittercity_tile',
};

const PRO_HOUSE_KEEPERS_KEY = 'ProHousekeepers_Housekeeping_Family';
const PRO_HOUSE_KEEPERS_TILE_DATA: PartnerTile = {
  logoImage: ProHouseKeepersLogo,
  companyName: 'Pro Housekeepers',
  category: PartnerCategory.careSupport,
  headerText: 'Hire the best with Pro Housekeepers',
  bodyText: 'Cleaners are background-checked and equipped with all supplies',
  ctaText: 'Learn More',
  ctaLink: 'https://prohousekeepers.com/book-now/',
};

const PRO_TRAININGS_CPR_FAMILY_KEY = 'ProTrainings_CPR_Family';
const PRO_TRAININGS_CPR_FAMILY_TILE_DATA: PartnerTile = {
  logoImage: ProTrainingsLogo,
  companyName: 'ProTrainings',
  category: PartnerCategory.caregiverDevelopment,
  headerText: 'Get 15% off CPR certification',
  bodyText: 'Learn from seasoned paramedics through virtual CPR courses',
  ctaText: 'View Training',
  ctaLink: 'https://www.protrainings.com/sittercity-families',
};

const MEET_CAREGIVERS_ELDER_CARE_KEY = 'MeetCaregivers_Elder_Care';
const MEET_CAREGIVERS_ELDER_CARE_TILE_DATA: PartnerTile = {
  logoImage: MeetCaregiversLogo,
  companyName: 'MeetCaregivers',
  category: PartnerCategory.careSupport,
  headerText: 'Find Personalized Senior Care',
  bodyText: 'Find caregivers for skilled medical care and daily activity support',
  ctaText: 'Learn More',
  ctaLink: 'https://www.meetcaregivers.com/find-a-caregiver/',
};

const GRAYCE_ELDER_CARE_KEY = 'Grayce_Elder_Care';
const GRAYCE_ELDER_CARE_TILE_DATA: PartnerTile = {
  logoImage: GrayceElderCareLogo,
  companyName: 'Grayce',
  category: PartnerCategory.careSupport,
  headerText: 'Get Expert Help To Find Specialized Care',
  bodyText: 'Expert care guidance for ill, disabled, and aging loved ones',
  ctaText: 'Learn More',
  ctaLink: 'https://withgrayce.com/buy/',
};

const BRIGHT_HORIZONS_CENTERS_KEY = 'BrightHorizons_Centers';
const BRIGHT_HORIZONS_CENTERS_TILE_DATA: PartnerTile = {
  logoImage: BrightHorizonsLogo,
  companyName: 'Bright Horizons',
  category: PartnerCategory.childCareCamps,
  headerText: 'Find High-Quality, Full-Time Child Care',
  bodyText: 'Childcare in a joyful setting with experienced caregivers at Bright Horizons®',
  ctaText: 'Find A Center',
  ctaLink:
    'https://www.brighthorizons.com/child-care-locator?utm_source=sittercity&utm_medium=org-digitalad&utm_campaign=leadmarketing&utm_term=sittercitydashboard&utm_content=centerlocator&IMS_SOURCE_SPECIFY=sittercity|org-digitalad|leadmarketing|sittercitydashboard|centerlocator',
};

export const PROTRAININGS_CPR_SITTER_KEY = 'ProTrainings_CPR_Sitter';
export const PROTRAININGS_CPR_SITTER_DATA: PartnerTile = {
  logoImage: ProTrainingsLogo,
  companyName: 'ProTrainings',
  headerText: 'Get 15% off CPR certification',
  bodyText: 'Learn how to handle over 50 different first aid scenarios from seasoned paramedics—all through a virtual experience',
  ctaText: 'View Training',
  ctaLink: 'https://www.protrainings.com/sittercity-caregivers',
  category: PartnerCategory.caregiverDevelopment,
};
const ALL_PARENT_PARTNER_TILES = () => ({
  [STEVE_AND_KATES_CAMPS_KEY]: STEVE_AND_KATES_CAMPS_TILE_DATA,
  [GTM_PARTNER_KEY]: GTM_PARTNER_TILE_DATA,
  [PRO_HOUSE_KEEPERS_KEY]: PRO_HOUSE_KEEPERS_TILE_DATA,
  [PRO_TRAININGS_CPR_FAMILY_KEY]: PRO_TRAININGS_CPR_FAMILY_TILE_DATA,
  [BRIGHT_HORIZONS_CENTERS_KEY]: BRIGHT_HORIZONS_CENTERS_TILE_DATA,
  [MEET_CAREGIVERS_ELDER_CARE_KEY]: MEET_CAREGIVERS_ELDER_CARE_TILE_DATA,
  [GRAYCE_ELDER_CARE_KEY]: GRAYCE_ELDER_CARE_TILE_DATA,
});

const ALL_PARENT_PARTNER_KEYS = Object.keys(ALL_PARENT_PARTNER_TILES());

const ALL_TILES = () => ({
  ...ALL_PARENT_PARTNER_TILES(),
  ProTrainings_CPR_Sitter: PROTRAININGS_CPR_SITTER_DATA,
});

export default {
  ALL_PARENT_PARTNER_TILES,
  ALL_PARENT_PARTNER_KEYS,
  ALL_TILES,
};
